
const Loading = () => {
  return (
    <div className="loader loading">
      <img src="/loader.svg" alt="loader" />
    </div>
  );
};
export default Loading
